/**
 * Preferences service singleton for the console.
 *
 * Descriptors must already be registered (via `bootstrapDataAccess` →
 * `registerDescriptors`) before `hydrate`. Adapters and non-React stores
 * import this instance directly — the React `PreferencesProvider` only owns
 * the hydrate / reset lifecycle.
 *
 * `resolveWithContext` is injected from the app `@rammetec/data-access` entry
 * so Vite cannot bind a duplicate `repositoryResolver` / empty `entityRegistry`
 * from the `/preferences` subpath chunk (flush would fail forever).
 */

import {
  createWebLocalStorageAdapter,
  repositoryResolver,
} from '@rammetec/data-access'
import { createPreferencesService } from '@rammetec/data-access/preferences'

export const preferencesService = createPreferencesService({
  storage: createWebLocalStorageAdapter(),
  resolveWithContext: (entityName, context) =>
    repositoryResolver.resolveWithContext(entityName, context),
})
